/* product-info のバリアント選択意図を DOM イベントから解決する */
(() => {
  const namespace = window.AuremeProductInfo || {};

  if (namespace.VariantSelectionIntent) {
    return;
  }

  const AUREME_COLOR_OPTION_SELECTOR = '.product-form__input--aureme-color';
  const AUREME_SIZE_OPTION_SELECTOR = '.product-form__input--aureme-size';

  /* fetch/render 本体から、選択元に応じた状態遷移の判定を分離する */
  class VariantSelectionIntent {
    constructor(productInfo) {
      this.productInfo = productInfo;
    }

    build({ eventTarget, selectedOptionTarget }) {
      const isColorOption = this.isColorOptionTarget(eventTarget);

      return {
        productUrl:
          selectedOptionTarget.dataset.productUrl ||
          this.productInfo.pendingProductInfoState?.requestUrl ||
          this.productInfo.dataset.url,
        sizeSelectionMode: this.getSizeSelectionMode(eventTarget),
        materialMode: this.getMaterialMode(eventTarget, isColorOption),
        mediaActivationOptions: this.getMediaActivationOptions(eventTarget, isColorOption),
        colorMediaId: this.getColorMediaId(selectedOptionTarget, isColorOption),
        shouldCancelCounterLock: !isColorOption,
      };
    }

    isColorOptionTarget(eventTarget) {
      return Boolean(eventTarget?.closest(AUREME_COLOR_OPTION_SELECTOR));
    }

    getSizeSelectionMode(eventTarget) {
      if (eventTarget.closest(AUREME_SIZE_OPTION_SELECTOR)) return 'manual';

      if (this.productInfo.currentSizeSelectionMode === 'manual') return 'manual';

      return 'auto';
    }

    getMaterialMode(eventTarget, isColorOption) {
      /*
       * 色選択ではカラー代表の素材表示へ戻し、サイズ選択だけ選択 variant の素材へ寄せる。
       * representative 系からのサイズ変更は、代表値を保ちつつ選択値が必要な項目だけ上書きできる mode にする。
       */
      if (isColorOption) return 'representative';

      if (!eventTarget?.closest(AUREME_SIZE_OPTION_SELECTOR)) {
        return this.productInfo.currentMaterialMode;
      }

      if (
        this.productInfo.currentMaterialMode === 'representative' ||
        this.productInfo.currentMaterialMode === 'representative_with_selected_override'
      ) {
        return 'representative_with_selected_override';
      }

      return 'selected';
    }

    getMediaActivationOptions(eventTarget, isColorOption) {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      const isVariantPickerOption = Boolean(eventTarget?.closest('variant-selects'));

      /*
       * 色選択は代表画像へ移動するが、PC はサムネイル位置だけ、SP は横スライダーの smooth scroll まで同期する。
       * サイズ選択はフォーム操作の継続を優先し、SP でビューポートを動かさない。
       */
      if (isColorOption) {
        if (isDesktop) {
          return {
            thumbnailAlign: 'start',
            allowViewportScroll: false,
          };
        }

        return {
          allowViewportScroll: true,
          viewerScrollBehavior: 'smooth',
          skipImmediateGallerySync: true,
          lockCounterUntilViewerScrollSettled: true,
        };
      }

      if (!isDesktop && isVariantPickerOption) {
        return {
          allowViewportScroll: false,
        };
      }

      return undefined;
    }

    getColorMediaId(target, isColorOption) {
      if (!isColorOption) return undefined;

      const mediaId = String(target.dataset?.auremeMediaId || '').trim();
      return mediaId || undefined;
    }
  }

  namespace.VariantSelectionIntent = VariantSelectionIntent;
  window.AuremeProductInfo = namespace;
})();
